import styled from '@emotion/styled';
import { MEDIA_QUERIES, Z_SCALE } from 'radiance-ui/lib/constants';
import { LinkButton, TYPOGRAPHY_STYLE } from 'radiance-ui';

import { mobileOnly } from 'styles/mixins/displayMobileDesktop';
import { LOCAL_COLORS } from 'styles/constants';

export const AnimationWrapper = styled.div<{ showStickyCta: boolean }>`
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000;
  position: fixed;
  width: 100%;
  z-index: ${Z_SCALE.e2000};
  bottom: 0;
  left: 0;
  transition: 240ms;

  ${MEDIA_QUERIES.xsUp} {
    padding-right: ${({ showStickyCta }) => (showStickyCta ? '0' : '30px')};
    padding-left: ${({ showStickyCta }) => (showStickyCta ? '0' : '30px')};
  }
`;

export const Title = styled.span`
  ${({ theme }) => TYPOGRAPHY_STYLE.button(theme)};
  color: ${({ theme }) => theme.COLORS.white};
  text-transform: capitalize;
`;

export const Disclaimer = styled.small`
  ${({ theme }) => TYPOGRAPHY_STYLE.label(theme)};
  text-transform: none;
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.fontWeight.normal};
  letter-spacing: normal;
`;

export const LinkButtonStyled = styled(LinkButton)`
  width: 100%;
  max-width: 100%;
  min-width: auto;
  border-radius: 0;
  height: 72px;
  text-align: center;
  background-color: ${LOCAL_COLORS.surfaceBrandBold};
  border-color: ${LOCAL_COLORS.surfaceBrandBold};
  ${mobileOnly()};

  small {
    color: ${({ theme }) => theme.COLORS.primaryTint4};
  }
`;
